import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { jsPDF } from 'jspdf';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tienda-imprimir-dialog',
  templateUrl: './tienda-imprimir-dialog.component.html',
  styleUrls: ['./tienda-imprimir-dialog.component.css']
})
export class TiendaImprimirDialogComponent implements OnInit {

  displayedColumns: string[] = [];
  datasource: any;
  dataSource: MatTableDataSource<any>;

  @ViewChild('tabla') tabla: ElementRef;
  @ViewChild('htmlData') htmlData: ElementRef;

  constructor(public dialogRef: MatDialogRef<TiendaImprimirDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.getGridTienda();
  }

  getGridTienda() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando registros ...'
    });
    Swal.showLoading();
    this.displayedColumns = ['idtienda', 'esactivo', 'nombre_comercial', 'email', 'telefono', 'movil'];
    this.dataSource = new MatTableDataSource<any>(this.data.row);
  //  console.log(this.data.row);
    Swal.close();

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  imprimir(cmpName) {
     const printContents = document.getElementById(cmpName).innerHTML;
     const originalContents = document.body.innerHTML;

     document.body.innerHTML = printContents;

     window.print();

     document.body.innerHTML = originalContents;
  }

  public openPDF(): void {
    const DATA = this.htmlData.nativeElement;
    const doc = new jsPDF('landscape', 'pt', 'letter', true);
    doc.html(DATA, { callback: (d) => d.output('dataurlnewwindow'), x: 15, y: 15 });
  }


  public downloadPDF(): void {
    const DATA = this.tabla.nativeElement;
    const doc = new jsPDF('p', 'pt', 'a4');

    doc.html(DATA, { callback: (d) => d.save('tienda.pdf'), x: 15, y: 15, width: 200 });
  }

}
